import { resolveI18n } from "../../../../commons/services/Translation"

export const detailCarrierCard = (i18n) => {
  return {
    dtWidth: resolveI18n({ i18n, ko: "140px", en: "230px", vi: "200px" }),
  }
}